/**
 * SlugField — the "Odkaz na webu" field shared by the pobočka and category forms: the URL key of the public site with the
 * pattern the server enforces and a "Z názvu" action that suggests one from the name.
 */

import { Field } from '@/components/Field';
import { LinkButton } from '@/components/LinkButton';
import { TextInput } from '@/components/TextInput';
import { SLUG_MAX, SLUG_PATTERN, slugZNazvu } from './otviraci-doba-helpers';

interface Props {
  value: string;
  onChange: (next: string) => void;
  /** The name the suggestion is made from. */
  nazev: string;
  placeholder: string;
  hint: string;
}

export function SlugField({ value, onChange, nazev, placeholder, hint }: Props) {
  return (
    <Field label="Odkaz na webu" optional="bez něj se na webu nezobrazí" hint={hint} span>
      <TextInput
        value={value}
        maxLength={SLUG_MAX}
        placeholder={placeholder}
        pattern={SLUG_PATTERN}
        title="Malá písmena bez diakritiky, číslice a pomlčky"
        onChange={(e) => onChange(e.currentTarget.value)}
      />
      <LinkButton type="button" className="ml-3 shrink-0" onClick={() => onChange(slugZNazvu(nazev))}>
        Z názvu
      </LinkButton>
    </Field>
  );
}
